"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const status_form_1 = __importDefault(require("./status.form"));
const Field_1 = __importDefault(require("../../_classes/field/Field"));
const AriFormUtils = __importStar(require("../../../utils/utils"));
/**
 * Here we will derive from the base component which all Ari.Form form components derive from.
 * @param component
 * @param options
 * @param data
 * @class
 */
class StatusComponent extends Field_1.default {
    constructor(component, options, data) {
        super(component, options, data);
        this.StatusData = {};
    }
    static schema(...extend) {
        return Field_1.default.schema({
            type: 'trackingStatus',
            label: 'Status',
            displayInfo: false,
            textContent: '',
            align: 'justify-content-start',
            action: 'event',
            key: 'trackingStatus',
            templatesTextinfo: StatusComponent.defaultRowTemplate,
        }, ...extend);
    }
    get defaultSchema() {
        return StatusComponent.schema();
    }
    get emptyValue() {
        return this.getValue();
    }
    renderIcon(iconType, icon, active, currentStep) {
        switch (iconType) {
            case 'bootstrap':
                return `<i class="bi ari-text-[18px] ${active ? "ari-text-green-500" : currentStep ? "ari-text-yellow-500" : "ari-text-gray-200"}  ${icon}"></i>`;
            case 'tabler-icons':
                return `<i class="ti ari-text-[18px] ${active ? "ari-text-green-500" : currentStep ? "ari-text-yellow-500" : "ari-text-gray-200"} ${icon}"></i>`;
            case 'material':
                return `<span class="material-icons ${active ? "ari-text-green-500" : "ari-text-gray-200"} ari-text-[18px]">${icon}</span>`;
            case 'custom':
                return `<img src="${icon}" alt="icon" class="custom-icon ari-w-[30px] ari-h-[30px] ari-object-contain"/>`;
            default:
                return '';
        }
    }
    renderStatusItems(dataStep) {
        return Object.keys(dataStep).length > 0
            ? dataStep.ListStep.map((value) => {
                const active = value.Priority <= dataStep.Step.Priority;
                const done = value.Priority < dataStep.Step.Priority;
                const icon = value.Icon ? JSON.parse(value.Icon) : {};
                const currentPriority = dataStep.Step.Priority;
                const nextPriority = Math.min(...dataStep.ListStep
                    .filter(s => s.Priority > currentPriority)
                    .map(s => s.Priority));
                const currenStep = value.Priority === (isFinite(nextPriority) ? nextPriority : null);
                return `
        <div class="status-item ari-max-w-[120px] ari-text-center ari-flex ari-flex-1 ari-flex-col ari-items-center ari-relative
        
        before:ari-content-['']
        before:ari-absolute
        before:ari-top-[13px]
        before:ari-left-0
        before:ari-w-1/2
        before:ari-h-[2px]
        before:ari-z-0
        ${active || currenStep ? "before:ari-bg-green-500" : "before:ari-bg-gray-400"}
        first:before:ari-hidden
        
        after:ari-content-['']
        after:ari-absolute
        after:ari-top-[13px]
        after:ari-right-0
        after:ari-w-1/2
        after:ari-h-[2px]
        after:ari-z-0
        ${done || active ? "after:ari-bg-green-500" : "after:ari-bg-gray-400"}
        last:after:ari-hidden
        ">

          <div class="status-step ari-relative ari-z-10 ari-bg-white
          ${active ? ' ari-border-green-500' : currenStep ? 'ari-border-yellow-500' : 'ari-border-gray-200'}
          ari-w-[30px] ari-h-[30px] ari-rounded-full ari-flex ari-items-center ari-justify-center ari-border">

            <div class="status-icon">
              ${this.renderIcon(icon.iconType, icon.icon, active, currenStep)}
            </div>

          </div>

          <div class="status-content ari-mt-[10px]">
            <div class="status-title ari-text-sm ari-font-semibold">${AriFormUtils.getLangText(active ? value.PrevStateName : value.CurrentStateName)}</div>
          </div>

        </div>`;
            }).join("")
            : `<div class="no-data">No status data available</div>`;
    }
    render() {
        var view = `<div ref="${this.component.key}-status-component" class="wraper-status-component ari-justify-center ari-flex  ari-items-start ari-min-w-[300px] ari-p-2">
      ${this.renderStatusItems(this.StatusData)}
    </div>`;
        return super.render(view);
    }
    setValue(value, flags = {}) {
        const changed = super.setValue(value, flags);
        if (changed) {
            this.StatusData = value || {};
            this.redraw();
        }
        return changed;
    }
    getValue() {
        return this.value;
    }
    /**
     * After the html string has been mounted into the dom, the dom element is returned here. Use refs to find specific
     * elements to attach functionality to.
     * @param element
     * @returns {Promise}
     */
    attach(element) {
        var refs = {};
        refs[`${this.component.key}-status-component`] = 'single';
        this.loadRefs(element, refs);
        return super.attach(element);
    }
}
StatusComponent.editForm = status_form_1.default;
StatusComponent.builderInfo = {
    title: 'Status',
    group: 'basic',
    icon: 'card-checklist',
    weight: 3,
    documentation: 'http://help.ari.form/userguide/',
    schema: StatusComponent.schema()
};
exports.default = StatusComponent;
